import { userActionTypes } from '../actionTypes';

const initialState = {
  isLoading: false,
  isLoginLoading: false,
  isVerifyLoading: false,
  isSignUpLoading: false,
  isEmployeesLoading: false,
  isClientsLoading: false,

  isSignUpSuccess: false,
  error: null,
  user: {},
  employees: [],
  clients: [],
  isLoggedIn: false,
};

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case userActionTypes.LOGIN_USER_START:
      return {
        ...state,
        isLoginLoading: true,
      };
    case userActionTypes.VERIFY_USER_START:
      return {
        ...state,
        isVerifyLoading: true,
      };
    case userActionTypes.SIGN_UP_USER_START:
      return {
        ...state,
        isSignUpLoading: true,
      };
    case userActionTypes.GET_CURRENT_USER_START:
      return {
        ...state,
        isLoading: true,
      };
    case userActionTypes.GET_ALL_EMPLOYEES_START:
      return {
        ...state,
        isEmployeesLoading: true,
      };
    case userActionTypes.GET_ALL_CLIENTS_START:
      return {
        ...state,
        isClientsLoading: true,
      };
    case userActionTypes.UPDATE_CLIENT_START:
      return {
        ...state,
        isClientProfileUpdating: true,
      };
    case userActionTypes.LOGOUT_USER:
      return {
        ...state,
        user: {},
        isLoggedIn: false,
      };
    case userActionTypes.SET_IS_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: true,
      };
    case userActionTypes.LOGIN_USER:
      return {
        ...state,
        isLoginLoading: false,
        error: null,
        isLoggedIn: true,
      };
    case userActionTypes.VERIFY_USER:
      return {
        ...state,
        isVerifyLoading: false,
        error: null,
        isLoggedIn: true,
      };
    case userActionTypes.SIGN_UP_USER:
      return {
        ...state,
        isSignUpLoading: false,
        error: null,
        isSignUpSuccess: true,
      };
    case userActionTypes.GET_CURRENT_USER:
      return {
        ...state,
        user: payload,
        isLoading: false,
        error: null,
      };
    case userActionTypes.GET_ALL_EMPLOYEES:
      return {
        ...state,
        isEmployeesLoading: false,
        employees: payload,
        error: null,
      };
    case userActionTypes.GET_ALL_CLIENTS:
      return {
        ...state,
        clients: payload,
        isClientsLoading: false,
        error: null,
      };
    case userActionTypes.UPDATE_CLIENT:
      return {
        ...state,
        client_profile: payload,
        isClientProfileUpdating: false,
        error: null,
      };
    case userActionTypes.LOGIN_USER_ERROR:
      return {
        ...state,
        isLoginLoading: false,
        error: payload,
      };
    case userActionTypes.VERIFY_USER_ERROR:
      return {
        ...state,
        isVerifyLoading: false,
        error: payload,
      };
    case userActionTypes.SIGN_UP_USER_ERROR:
      return {
        ...state,
        isSignUpLoading: false,
        error: payload,
      };
    case userActionTypes.GET_CURRENT_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case userActionTypes.GET_ALL_EMPLOYEES_ERROR:
      return {
        ...state,
        isEmployeesLoading: false,
        error: payload,
      };
    case userActionTypes.GET_ALL_CLIENTS_ERROR:
      return {
        ...state,
        isClientsLoading: false,
        error: payload,
      };
    case userActionTypes.UPDATE_CLIENT_ERROR:
      return {
        ...state,
        isClientProfileUpdating: false,
        error: payload,
      };
    default:
      return state;
  }
};

export default userReducer;
